import React, { useCallback } from "react"
import routes from "routes"
import { Order } from "src/components/hooks/useCreatorSearch"
import Link from "next/link"

type Props = {
  title: string
  searchWord?: string
  isTieup?: "all" | ""
  setIsTieup?: (state: "all" | "") => void
  setOrder?: (state: Order) => void
  setIsOverCharLimit?: (state: "yes" | "") => void
  order?: Order
  showOrder?: boolean
  showTieupToggle?: boolean
  showR18?: boolean
  handleChangeR18Toggle?: () => void
  showR18Toggle?: boolean
  showOverCharLimitToggle?: boolean
  isOverCharLimit?: "yes" | ""
  showSearchLink?: boolean
  showCharacterSearch?: boolean
  place?: string
  isTieupList?: boolean
}

const SearchResultHeader: React.FC<Props> = ({
  title,
  searchWord = "",
  isTieup = "",
  setIsTieup,
  setOrder,
  setIsOverCharLimit,
  order,
  showOrder = true,
  showTieupToggle = true,
  showSearchLink = true,
  showCharacterSearch = true,
  showR18 = false,
  handleChangeR18Toggle,
  showR18Toggle = false,
  isOverCharLimit = "",
  showOverCharLimitToggle = false,
  place = "novels",
  isTieupList,
}) => {
  const handleChangeTieupToggle = useCallback(() => {
    if (!setIsTieup) return
    setIsTieup(isTieup === "all" ? "" : "all")
  }, [isTieup, setIsTieup])

  const handleChangeOverCharLimitToggle = useCallback(() => {
    if (!setIsOverCharLimit) return
    setIsOverCharLimit(isOverCharLimit === "yes" ? "" : "yes")
  }, [isOverCharLimit, setIsOverCharLimit])

  return (
    <header className="p-searchResult-header">
      <div className="p-searchResult-header-inner">
        <div className="p-searchResult-col01">
          <h1 className="p-searchResult-title">{title}</h1>
          {!isTieupList && (
            <div className="p-searchResult-col01-inner">
              <p className="p-searchResult-detail">
                {searchWord.length ? `「${searchWord}」の検索結果` : ""}
              </p>
              <span
                style={{ width: order === "popularity" ? "140px" : "100px" }}
                className="p-searchResult-col01-select p-searchResult-select"
              >
                <select
                  className="p-searchResult-select-body"
                  name="search-result-filter"
                  value={order}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    setOrder && setOrder(e.target.value as Order)
                  }}
                >
                  <option value="">並べ替え</option>
                  <option value="date">新着順</option>
                  {place === "novels" && (
                    <option value="popularity">ブックマーク順</option>
                  )}
                </select>
              </span>
            </div>
          )}
        </div>
        <div className="p-searchResult-col02">
          {showSearchLink && (
            <ul className="p-searchResult-nav">
              <li>
                <Link href={routes.creatorSearchGenres(place)}>
                  <a className="c-textLink-gray">ジャンルで再検索</a>
                </Link>
              </li>
              {showCharacterSearch && (
                <li>
                  <Link href={routes.creatorSearchCharacters()}>
                    <a className="c-textLink-gray">キャラクターで再検索</a>
                  </Link>
                </li>
              )}
            </ul>
          )}
          {showOrder && (
            <span
              style={{ width: order === "popularity" ? "140px" : "100px" }}
              className="p-searchResult-col02-select p-searchResult-select"
            >
              <select
                className="p-searchResult-select-body"
                name="search-result-filter"
                value={order}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  setOrder && setOrder(e.target.value as Order)
                }}
              >
                <option value="">並べ替え</option>
                <option value="date">新着順</option>
                {place === "novels" && (
                  <option value="popularity">ブックマーク順</option>
                )}
                {/* <option value="recommended">おすすめ</option> */}
              </select>
            </span>
          )}
          {showTieupToggle && (
            <label className="p-searchResult-toggle">
              <span className="p-searchResult-toggle-label">
                たいあっぷ申請不可作品も表示
              </span>
              <input
                className="p-searchResult-toggle-input"
                type="checkbox"
                name="たいあっぷ申請不可作品表示"
                value="たいあっぷ申請不可作品も表示する"
                onChange={() => handleChangeTieupToggle()}
                checked={isTieup === "all"}
              />
              <span className="p-searchResult-toggle-button"></span>
            </label>
          )}
          {showR18Toggle && handleChangeR18Toggle && (
            <label className="p-searchResult-toggle">
              <span className="p-searchResult-toggle-label">
                18禁コンテンツの表示
              </span>
              <input
                className="p-searchResult-toggle-input"
                type="checkbox"
                name="18禁コンテンツの表示"
                value="18禁コンテンツを表示する"
                onChange={() => handleChangeR18Toggle()}
                checked={showR18}
              />
              <span className="p-searchResult-toggle-button"></span>
            </label>
          )}
          {showOverCharLimitToggle && (
            <label className="p-searchResult-toggle">
              <span className="p-searchResult-toggle-label">
                45,000字以上の作品のみ表示
              </span>
              <input
                className="p-searchResult-toggle-input"
                type="checkbox"
                name="45,000字以上の作品のみ表示"
                value="45,000字以上の作品のみ表示する"
                onChange={() => handleChangeOverCharLimitToggle()}
                checked={isOverCharLimit === "yes"}
              />
              <span className="p-searchResult-toggle-button"></span>
            </label>
          )}
        </div>
      </div>
    </header>
  )
}

export default SearchResultHeader
